import { render, staticRenderFns } from "./VerificationDetailsCompanyInfo.vue?vue&type=template&id=be19fd2e&"
import script from "./VerificationDetailsCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./VerificationDetailsCompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./VerificationDetailsCompanyInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports